import React, { useEffect, useState, useCallback, useRef, useMemo } from "react";
import MetaTags from "react-meta-tags";
import { useDispatch, useSelector } from "react-redux";
import {
    Col,
    Container,
    Modal,
    Row,
    Card,
    CardBody
} from "reactstrap";
import Select from 'react-select';
//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import { userModuleData } from 'helpers/basic_helper';
//i18n
// import Mdatatable from "components/Datatables/Mdatatables";
import Notifications from "components/Notifications";
import { post, get } from 'helpers/api_helper';
import { CONVERTINVOICE_URL, INVOICE_CANCEL_URL, INVOICE_URL, WHATSAPP_TEST_URL } from 'helpers/url_helper';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getInvoices } from "store/actions";
import PrintModel from "./print";
import { months } from 'constants/layout'
import { clientOptions } from "store/actions";
import Datatables from "components/Datatables/datatable";
import { Link } from "react-router-dom";
import LoaderCard from "modules/loader";
import getYearOptions from "../Utility/getYears";
import moment from "moment";
import toastr from "toastr";
import { getBasePermissions } from "modules/Utility/getPermission";
import { runBatchLoader } from "utils/batchLoader";
import RequestEditModal from "modules/Approvals/components/RequestEditModal";

const isType = 'invoice'
const inputObj = {
    code: null,
    remark: ""
}

const confirmmationData = {
    date: new Date(),
    remark: ""
}

const InvoiceReport = () => {
    const module = getBasePermissions('invoice, proforma');
    const canAddInvoices = module?.isAdmin || Boolean(module?.menu?.invoice?.invoices?.add) || Boolean(module?.menu?.invoice?.proforma?.add);
    const canDeleteInvoices = module?.isAdmin || Boolean(module?.menu?.invoice?.invoices?.delete) || Boolean(module?.menu?.invoice?.proforma?.delete);
    const canEditInvoices = module?.isAdmin || Boolean(module?.menu?.invoice?.invoices?.edit) || Boolean(module?.menu?.invoice?.proforma?.edit);
    const dispatch = useDispatch()
    const invoiceType = window?.location?.pathname.includes('proforma') ? 'Proforma' : '';

    const { DDOptions } = useSelector(state => state.Master);
    const { loading, invoices } = useSelector(state => state.Invoices);
    const [dataRows, setDataRows] = useState([]);
    const [clientsDD, setClientsDD] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
    const [confirmationInput, setConfirmationInput] = useState(inputObj);
    const [isRequestEditModalOpen, setIsRequestEditModalOpen] = useState(false);
    const [requestEditDoc, setRequestEditDoc] = useState(null);
    const [isActions, setIsActions] = useState(false)
    const [isActionColumn, setIsActionColumn] = useState(false)
    const [confirmConvertModal, setConfirmConvertModal] = useState(null)
    const [confirmConvertData, setConfirmConvertData] = useState(confirmmationData)
    const [isOrdersList, setIsOrdersList] = useState(null)
    const [openBulkModal, isOpenBulkModal] = useState(false)
    const [convertingOrders, setConvertingOrders] = useState({ lock: [], revert: [] })
    // const [filterMonth, setFilterMonth] = useState(null)
    // const [filterClient, setFilterClient] = useState(null)
    // const [filterInvoice, setFilterInvoice] = useState(null)
    const [finalInvoiceReview, setFinalInvoiceReview] = useState(null)
    const [invoiceRageBulkPrint, setInvoiceRageBulkPrint] = useState({
        start: null,
        end: null
    })
    const [orderTotals, setOrderTotals] = useState({ lock: 0, revert: 0 });
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        search: ''
    })

    const [batchProgress, setBatchProgress] = useState(null);
    const batchCancelRef = useRef(false);
    const isBatchRunningRef = useRef(false);
    const totalRowsRef = useRef(0);

    useEffect(() => {
        totalRowsRef.current = dataRows?.total_rows || invoices?.total_rows || 0;
    }, [dataRows?.total_rows, invoices?.total_rows]);

    const handleCancelBatch = () => {
        batchCancelRef.current = true;
        isBatchRunningRef.current = false;
        setBatchProgress(prev => prev ? ({ ...prev, active: false, stopped: true }) : null);
    };

    const handlePaginationChange = useCallback((newPag) => {
        setPagination(prev => {
            if (
                prev.page === newPag.page &&
                prev.limit === newPag.limit &&
                prev.search === newPag.search &&
                Boolean(prev.isAll) === Boolean(newPag.isAll)
            ) {
                return prev;
            }
            return { ...prev, ...newPag };
        });
    }, []);

    const [filters, setFilters] = useState({
        'invoice': '',
        'month': '',
        'year': '',
        'client': ''
    })
    const years = useMemo(() => getYearOptions(), []);
    const lastQueryRef = useRef('');

    const getClients = async () => {
        const res = await get(`api/selectors/getClientsOptions?type=billto`)
        if (res?.status == 200) {
            setClientsDD(res.response?.clients)
        }
    }

    const getData = useCallback(async (type = invoiceType, forceRefresh = false) => {
        const isAllSelected = pagination?.isAll || pagination?.limit === 'all' || pagination?.limit === 'All' || (typeof pagination?.limit === 'number' && pagination?.limit > 100);

        const defaultYear = years[0]?.value || moment().format('YYYY');
        const baseFilter = {
            'invoice': filters?.invoice || '',
            'month': filters?.month?.value || '',
            'year': filters?.year?.value || defaultYear,
            'client': filters?.client?.value || '',
            'type': type ? 'Proforma' : '',
            'searchTerm': pagination?.search || '',
        };

        if (isAllSelected) {
            lastQueryRef.current = '';
            batchCancelRef.current = true;
            await new Promise(r => setTimeout(r, 60));
            batchCancelRef.current = false;
            isBatchRunningRef.current = true;

            await runBatchLoader({
                fetchPage: async (page, batchSize) => {
                    const q = new URLSearchParams({
                        ...baseFilter,
                        page,
                        limit: batchSize,
                    }).toString();
                    const res = await get(`${INVOICE_URL}?${q}`);
                    if (res && res.status === 200 && res.response) {
                        return res.response;
                    }
                    return { rows: [], total_rows: 0 };
                },
                batchSize: 250,
                initialTotal: totalRowsRef.current || 0,
                onProgress: setBatchProgress,
                onRowsLoaded: (rows, total) => {
                    setDataRows({
                        total_rows: total,
                        rows: [...rows]
                    });
                },
                cancelRef: batchCancelRef,
                runningRef: isBatchRunningRef,
            });
            return;
        }

        // Normal single page request
        batchCancelRef.current = true;
        isBatchRunningRef.current = false;
        setBatchProgress(null);

        const filterObj = {
            ...baseFilter,
            'limit': pagination?.limit || 10,
            'page': pagination?.page || 1,
        };
        const queryParams = new URLSearchParams(filterObj).toString();
        const requestUrl = `${INVOICE_URL}?${queryParams}`;

        if (!forceRefresh && lastQueryRef.current === requestUrl) {
            return;
        }
        lastQueryRef.current = requestUrl;

        dispatch(getInvoices({ url: requestUrl }));
    }, [filters, pagination, invoiceType, years]);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            getData();
        }, 300);

        return () => clearTimeout(timeoutId);
    }, [getData]);

    useEffect(() => {
        return () => {
            batchCancelRef.current = true;
            isBatchRunningRef.current = false;
        };
    }, []);

    useEffect(() => {
        let isMounted = true;
        dispatch(clientOptions({ type: 'billto' }));
        const loadModuleData = async () => {
            const data = await userModuleData('invoice', 'invoices');
            if (isMounted) {
                setIsActions(data);
                if (data) {
                    data.add = false;
                    data.pdf = true;
                    data.sendwp = true;
                    data.delete = false;
                    data.edit = false;
                    data.lock = true;
                    setIsActionColumn(true);
                }
            }
        };
        loadModuleData();
        return () => {
            isMounted = false;
        };
    }, [invoiceType]);

    useEffect(() => {
        if (!isBatchRunningRef.current) {
            setDataRows(invoices);
        }
    }, [invoices]);

    // table Column Data
    let datatableData = [
        {
            dataField: 'invoice_number',
            text: `${invoiceType} Invoice`,
            formatter: (cell, row) => {
                if (invoiceType !== 'Proforma') {
                    const num = row.invoice_number;
                    return `${num.slice(0, 4)} - ${num.slice(4, 6)} / ${num.slice(6)}`;
                } else {
                    return row.invoice_number
                }
            },
        }, {
            dataField: 'clientname',
            text: 'Client / Doctor'
        }, {
            dataField: 'invoice_date',
            text: 'Invoice Date (DDMMYYYYY)'
        }, {
            dataField: 'invoice_total',
            text: 'Total Amount ( ₹ )',
            formatter: (cell, row) => (parseFloat(row.invoice_total) + parseFloat(row.invoice_total) * 0.05).toLocaleString('en-IN', {
                style: 'currency',
                currency: 'INR',
            }),
        }, {
            dataField: 'invoice_status',
            text: 'Invoice Status',
            formatter: (cell, row) => {
                if (row.invoice_status == 1) {
                    return <span className="badge badge-soft-danger">Cancelled</span>
                } else {
                    return <span>--</span>
                }
            },
        }, {
            dataField: 'action',
            text: 'Action',
            isDummyField: true,
            formatter: (cell, row) => <>
                <Link to="#" className="ms-1 btn btn-outline-primary btn-sm edit" onClick={() => {
                    window.open(`/invoice/print?invoice_number=${row.invoice_number}${invoiceType ? '&type=proforma' : ''}`, '_blank');
                }} title="Track or status" ><i className={`fas fa-file-pdf`} /></Link>

                <Link to="#" className="ms-1 btn btn-outline-success btn-sm edit" onClick={() => wpinvoice(row, 'proforma')} title={"Send Invoice to Client"} ><i className={`fab fa-whatsapp fa-1x`} /></Link>

                {!module?.isAdmin && row?.invoice_status == 0 && (
                    <Link
                        to="#"
                        className="ms-1 btn btn-outline-warning btn-sm"
                        onClick={() => {
                            setRequestEditDoc(row);
                            setIsRequestEditModalOpen(true);
                        }}
                        title="Request Edit / Modification Approval"
                    >
                        <i className="mdi mdi-lock-alert" />
                    </Link>
                )}

                {
                    ((invoiceType == 'Proforma' && row.is_lock == 0) && (canAddInvoices || canEditInvoices)) ?
                        <>
                            <Link to="#" className={`ms-1 btn btn-outline-danger ${row.status == 1 ? " disabled" : ''} btn-sm`} onClick={() => setConfirmConvertModal(row)} ><i className={`fas fa-arrow-right`} /></Link>
                            {
                                canDeleteInvoices &&
                                <Link to="#" className={`ms-1 btn btn-outline-danger ${row.status == 1 ? " disabled" : ''} btn-sm`} onClick={() => setOpenConfirmationModal(row.invoice_number)} ><i className={`mdi mdi-close-thick`} /></Link>
                            }
                        </> :
                        invoiceType == 'Proforma' ? <Link to="#" className={`ms-1 btn btn-outline-success ${row.status == 1 ? " disabled" : ''} btn-sm`} onClick={
                            () => {
                                window.open(`/invoice/print?invoice_number=${row.final_invoice}`, '_blank');
                            }
                        } ><i className={`fas fa-eye`} /></Link> :
                            (row?.invoice_status == 0 && canDeleteInvoices) ?
                                <Link to="#" className={`ms-1 btn btn-outline-danger ${row.status == 1 ? " disabled" : ''} btn-sm`} onClick={() => setFinalInvoiceReview(row)} ><i className={`mdi mdi-close-thick`} /></Link> : ''
                }
            </>
        }
    ];

    if (invoiceType !== 'Proforma') {
        datatableData?.splice(2, 0, {
            text: 'Proforma Invoice',
            dataField: 'proforma_invoice_number',
            formatter: (cell, row) => row?.proforma_invoice_number?.split(',')?.map(v =>
                <Link key={`L_${v}`} to="#" className="ms-1 btn btn-outline-danger btn-sm" onClick={() => {
                    window.open(`/invoice/print?invoice_number=${v}&type=proforma`, '_blank');
                }} title="View proforma invoice" >{v}</Link>
            )
        })
    }

    const closeModel = (data) => {
        setIsOpen(data)
        setDataRows([])
    }

    const cancelinvoiceConfirm = async () => {
        const res = await post(INVOICE_CANCEL_URL, confirmationInput)
        if (res.status == 200) {
            Notifications(`Invoice Cancelled.!`, 'success')
            getData(invoiceType, true)
            setConfirmationInput(inputObj)
            setOpenConfirmationModal(false)
        } else {
            Notifications(res?.message || `Please, try again.!`, 'error')
        }
    }

    const ConvertInvoice = async (INO, invoices) => {
        const lock = convertingOrders?.lock?.map(v => v.number)
        const revert = convertingOrders?.revert?.map(v => v.number)
        const t = {
            lock,
            revert,
            lock_value: convertingOrders?.lock?.reduce((acc, curr) => acc + parseFloat(curr.value || 0), 0),
            revert_value: convertingOrders?.revert?.reduce((acc, curr) => acc + parseFloat(curr.value || 0), 0),
        }
        const Obj = {
            "proforma_invoice_number": invoices && invoices.trim() != '' && invoices.split(',').length > 1 ? invoices : INO?.invoice_number,
            "invoice_date": confirmConvertData?.date,
            "bill_to": confirmConvertData?.client_id?.value,
            "remark": confirmConvertData?.remark,
            'orders': JSON.stringify(t)
        }

        const res = await post(`${CONVERTINVOICE_URL}`, Obj);

        if (res?.status === 200) {
            setConvertingOrders({ lock: [], revert: [] })
            setConfirmConvertData(confirmmationData)
            setConfirmConvertModal(false)
            window.open(`/invoice/print?invoice_number=${res?.response?.invoice_no}`, '_blank');
            getData(invoiceType, true);
        }
    }

    const wpinvoice = async (data, type) => {
        const res = await post(`${WHATSAPP_TEST_URL}`, { ...data, type });
        if (res?.status === 200) {
            Notifications(`Invoice Send to Whatsapp.!`, 'success')
        } else {
            Notifications(`Please, try again.!`, 'error')
        }
    }

    useEffect(() => {
        getOrders()
    }, [confirmConvertModal])

    const getOrders = async () => {
        if (confirmConvertModal) {
            const res = await get(`/api/invoice/piorders?_invoice=${confirmConvertData?.proforma || confirmConvertModal.invoice_number}`)
            if (res?.status == 200) {
                setConfirmConvertData(p => ({ ...p, client_id: DDOptions?.clients?.filter(v => v.value == confirmConvertModal?.client_id) }))
                const data = res?.response[0]?.order_no;
                setIsOrdersList(data);
                const initialTotal = data.reduce((acc, curr) => acc + parseFloat(curr.value || 0), 0);
                setOrderTotals({
                    lock: initialTotal,
                    revert: 0
                });
                setConvertingOrders({
                    lock: data,
                    revert: []
                });
                setConvertingOrders({ lock: data, revert: [] })
            }
        }
    }

    // const handleCheckbox = (e) => {
    //     const input = e.target;
    //     const orderNumber = input.value;
    //     const orderValue = parseFloat(input.getAttribute('data-value')) || 0;
    //     const type = input.getAttribute('data-type');

    //     if (type === 'lock') {
    //         setConvertingOrders(prev => ({
    //             lock: [...prev.lock.filter(item => item.number !== orderNumber), { number: orderNumber, value: orderValue }],
    //             revert: prev.revert.filter(item => item.number !== orderNumber)
    //         }));
    //         setOrderTotals(prev => ({
    //             lock: prev.lock + orderValue,
    //             revert: prev.revert - orderValue
    //         }));
    //     } else {
    //         setConvertingOrders(prev => ({
    //             lock: prev.lock.filter(item => item.number !== orderNumber),
    //             revert: [...prev.revert.filter(item => item.number !== orderNumber), { number: orderNumber, value: orderValue }]
    //         }));
    //         setOrderTotals(prev => ({
    //             lock: prev.lock - orderValue,
    //             revert: prev.revert + orderValue
    //         }));
    //     }
    // };

    const handleCheckbox = (e) => {
        const input = e.currentTarget;
        const orderNumber = String(input.value);
        const orderValue = Number(input.dataset.value) || 0;
        const type = input.dataset.type; // "lock" or "cancel"

        setConvertingOrders((prev) => {
            // remove from both lists first
            let lock = prev.lock.filter((i) => i.number !== orderNumber);
            let revert = prev.revert.filter((i) => i.number !== orderNumber);

            // add to the chosen list
            const item = { number: orderNumber, value: orderValue };
            if (type === "lock") lock.push(item);
            else revert.push(item);

            // recompute totals safely
            const lockTotal = lock.reduce((s, it) => parseFloat(s) + parseFloat(it.value), 0);
            const revertTotal = revert.reduce((s, it) => parseFloat(s) + parseFloat(it.value), 0);

            setOrderTotals({ lock: lockTotal, revert: revertTotal });

            return { lock, revert };
        });
    };


    const handleBulkPrint = async () => {
        const { start, end } = invoiceRageBulkPrint;
        const startInvoice = start.replace(/[^0-9]/g, '');
        const endInvoice = end.replace(/[^0-9]/g, '');

        if (startInvoice && endInvoice) {
            const t = invoiceType ? 'proforma' : 'tax';
            if (t == 'proforma') {
                window.open(`/api/bulk/${t}/invoices?_from=${startInvoice}&_to=${endInvoice}`, '_blank');
            } else {
                const { success, message } = await get(`/bulk/${t}/invoices?_from=${startInvoice}&_to=${endInvoice}`);
                if (success) {
                    isOpenBulkModal(false)
                    toastr.success(message, 'Success');
                }
            }
        }
    }

    const getInvoiceFormate = (num) => {
        return `${num.slice(0, 4)} - ${num.slice(4, 6)} / ${num.slice(6)}`;
    }

    const cancelTaxInvoiceConfirm = async () => {
        const obj = {
            "invoice_no": finalInvoiceReview.invoice_number,
            "remark": finalInvoiceReview.remark,
            "proforma": finalInvoiceReview.proforma_invoice_number
        }

        const res = await post(`${INVOICE_CANCEL_URL}?type=tax`, obj)
        if (res.status == 200) {
            Notifications(`Invoice Cancelled.!`, 'success')
            getData(invoiceType, true)
            setFinalInvoiceReview(false)
        } else {
            Notifications(res?.message || `Please, try again.!`, 'error')
        }
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Dashboard | {isType}</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title="Masters"
                        breadcrumbItem={isType}
                    />

                    <Card>
                        <CardBody>
                            <Row>
                                <Col md={3}>
                                    <label>Search by Order or Modal Number</label>
                                    <input className="form-control" placeholder="Please Search using Invoice Number" onChange={(e) => setFilters(prev => ({ ...prev, invoice: e.target.value }))} />
                                </Col>
                                <Col md={3}>
                                    <label>Select Client or Doctor</label>
                                    <Select
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999 })
                                        }}
                                        onChange={(e) => setFilters(prev => (({ ...prev, client: e })))}
                                        isClearable={true}
                                        isSearch={true}
                                        value={filters?.client}
                                        options={DDOptions?.clients}
                                        name={'client'}
                                        required={false}
                                        placeholder={'Select Client'}
                                    />
                                </Col>
                                <Col md={3}>
                                    <label>Year</label>
                                    <Select
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999 })
                                        }}
                                        onChange={(e) => setFilters(prev => (({ ...prev, year: e })))}
                                        isClearable={true}
                                        value={filters?.year || years[0]}
                                        options={years}
                                        name={'year'}
                                        required={false}
                                        placeholder={'Select Year'}
                                    />
                                </Col>
                                <Col md={3}>
                                    <label>By Month</label>
                                    <Select
                                        styles={{
                                            menu: provided => ({ ...provided, zIndex: 9999 })
                                        }}
                                        onChange={(e) => setFilters(prev => (({ ...prev, month: e })))}
                                        isClearable={true}
                                        value={filters?.month || months[moment().format('M') - 1]}
                                        options={months}
                                        name={'month'}
                                        required={false}
                                        placeholder={'Select Month'}
                                    />
                                </Col>
                                {/* <Col md={2} className="text-end">
                                    <button className="btn btn-primary" style={{marginTop: '28px'}} onClick={() => getData(invoiceType)}>Filter Invoices</button>
                                </Col> */}
                            </Row>
                        </CardBody>
                    </Card>
                    <Card>
                        <CardBody>
                            <Datatables
                                isSearch={true}
                                columns={datatableData}
                                showTableOnly={true}
                                rowsLength={dataRows?.total_rows || 0}
                                rows={dataRows?.rows || []}
                                keyField={'invoice_number'}
                                handleAddButton={() => {
                                    isOpenBulkModal(true)
                                }}
                                title={`All  ${invoiceType} Invoices`}
                                loading={loading && (!batchProgress || batchProgress.loaded === 0)}
                                batchProgress={batchProgress}
                                onCancelBatch={handleCancelBatch}
                                isAdd={canAddInvoices}
                                btnTitle="Bulk Print"
                                isTableHead={true}
                                ssr={handlePaginationChange}
                            />
                        </CardBody>
                    </Card>

                    {
                        dataRows && <PrintModel isOpen={isOpen} closeModel={closeModel} />
                    }

                </Container>
            </div>

            {
                openBulkModal &&
                <Modal
                    size="md"
                    isOpen={openBulkModal !== false}
                    toggle={() => isOpenBulkModal(false)}
                    centered={true}
                >
                    <div className="modal-body">
                        <p>Please Enter Invoice Number Range.</p>
                        <label>Starting Invoice Number *</label>
                        <input name="text" onChange={(e) => setInvoiceRageBulkPrint(prev => ({ ...prev, start: e.target.value }))} className="form-control" /> <br />

                        <label>Ending Invoice Number *</label>
                        <input name="text" onChange={(e) => setInvoiceRageBulkPrint(prev => ({ ...prev, end: e.target.value }))} className="form-control" /> <br />
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => isOpenBulkModal(false)}>Close</button>
                        <button type="button" className="btn btn-primary" disabled={(invoiceRageBulkPrint?.start == null || invoiceRageBulkPrint?.end == null)} onClick={handleBulkPrint}>Print</button>
                    </div>
                </Modal>
            }

            {
                openConfirmationModal &&
                <Modal
                    size="md"
                    isOpen={openConfirmationModal !== false}
                    toggle={() => setOpenConfirmationModal(false)}
                    centered={true}
                >
                    <div className="modal-body">
                        <p>Please Enter Invoice Number: <b><u>{openConfirmationModal}</u></b> for Cancellation.</p>
                        <label>Invoice Number*</label>
                        <input name="date" onChange={(e) => setConfirmationInput(prev => ({ ...prev, code: e.target.value }))} className="form-control" /> <br />
                        <label>Remark*</label>
                        <input name="remark" onChange={(e) => setConfirmationInput(prev => ({ ...prev, remark: e.target.value }))} className="form-control" />
                    </div>
                    <span className="text-danger ms-5 mb-2 fw-bold" style={{ fontSize: '14px' }}>Once the invoice is canceled, it cannot be reverted back.</span>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setOpenConfirmationModal(false)} >Close</button>
                        <button
                            type="button"
                            disabled={(openConfirmationModal == confirmationInput.code && confirmationInput.remark.length > 5) ? false : true}
                            className={`btn btn-danger`}
                            onClick={cancelinvoiceConfirm} >Delete</button>
                    </div>
                </Modal>
            }
            {
                finalInvoiceReview &&
                <Modal
                    size="md"
                    isOpen={finalInvoiceReview !== false}
                    toggle={() => setFinalInvoiceReview(false)}
                    centered={true}
                >
                    <div className="modal-body">
                        <p>Please Review Invoice.</p>
                        <label>Invoice #. {getInvoiceFormate(finalInvoiceReview?.invoice_number)}</label><br />
                        <label>Client. {finalInvoiceReview?.clientname}</label><br />
                        <label>Proforma #. {finalInvoiceReview?.proforma_invoice_number?.split(',')}</label><br />
                        <label>Invoice Total #. {(parseFloat(finalInvoiceReview?.invoice_total) + parseFloat(finalInvoiceReview?.invoice_total) * 0.05).toLocaleString('en-IN', {
                            style: 'currency',
                            currency: 'INR',
                        })}</label><br />
                        <label>Remark *</label>
                        <input type="text" onChange={(e) => setFinalInvoiceReview(prev => ({ ...prev, remark: e.target.value }))} name="remark" className="form-control" />
                    </div>
                    <span className="text-danger ms-5 mb-2 fw-bold" style={{ fontSize: '14px' }}>Once the invoice is canceled, it cannot be reverted back.</span>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setFinalInvoiceReview(false)} >Close</button>
                        <button
                            type="button"
                            disabled={(finalInvoiceReview.remark?.length > 5) ? false : true}
                            className={`btn btn-danger`}
                            onClick={cancelTaxInvoiceConfirm} >Delete</button>
                    </div>
                </Modal>
            }

            {
                confirmConvertModal &&
                <Modal
                    size="md"
                    isOpen={confirmConvertModal !== false}
                    toggle={() => setConfirmConvertModal(false)}
                    centered={true}
                >
                    <div className="modal-body">
                        {/* <p>Please Enter Invoice Number: <b><u>{confirmConvertData}</u></b> for Convert to Invoice.</p> */}
                        <div className="row">
                            <span className="text-danger mb-2 fw-bold" style={{ fontSize: '14px' }}>Once the invoice is Locked, it cannot be reverted back.</span>
                            <div className='col-6'>
                                <label>Invoice Date*</label>
                                {/* <DatePicker
                                    className="form-control"
                                    minDate={new Date(confirmConvertModal?.invoice_date?.split('-').reverse().join('-'))}
                                    selected={new Date()}
                                    onChange={(date) => setConfirmConvertData(prev => ({...prev, date: date}))} /> */}
                                <DatePicker
                                    className="form-control"
                                    selected={confirmConvertData?.date || new Date()}
                                    onChange={(date) => setConfirmConvertData(prev => ({ ...prev, date }))}
                                    minDate={moment().subtract(2, "months").toDate()} />
                            </div>
                            <div className='col-6'>
                                <label>Remark*</label>
                                <input name="remark" onChange={(e) => setConfirmConvertData(prev => ({ ...prev, remark: e.target.value }))} className="form-control" />
                            </div>
                        </div>
                        <Row className="mt-2">
                            <Col md={12}>
                                <label>Bill To*</label>
                                <Select
                                    onChange={(e) => {
                                        setConfirmConvertData(prev => ({ ...prev, client_id: e }))
                                    }}
                                    isClearable={true}
                                    value={confirmConvertData?.client_id || null}
                                    options={DDOptions?.clients}
                                    name='clients'
                                    required={false}
                                    placeholder={'Select Worktype'}
                                />
                            </Col>
                        </Row>
                        <Row className="mt-2">
                            <Col md={12}>
                                <label>Add Performa</label>
                                <div className="input-group">
                                    <input className="form-control" defaultValue={confirmConvertModal?.invoice_number} onChange={(e) => setConfirmConvertData(prev => ({ ...prev, proforma: e.target.value }))} />
                                    <button className="btn btn-primary" onClick={() => getOrders()}>Submit</button>
                                </div>
                            </Col>
                        </Row>

                        <div className="row mt-2">
                            {
                                isOrdersList ?
                                    <div style={{ maxHeight: '480px', overflowX: 'auto' }}>
                                        <table className="table table-borderd">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Order Value</th>
                                                    <th>Order #</th>
                                                    <th className="text-center">Lock</th>
                                                    <th className="text-center">Cancel</th>
                                                </tr>
                                            </thead>
                                            <tbody style={{ overflowY: 'auto' }}>
                                                {isOrdersList?.map((v, i) => {
                                                    return <tr key={`OLPI_${i}`}>
                                                        <td>{i + 1}</td>
                                                        <td>₹ {v.value}</td>
                                                        <td>{v.number}</td>
                                                        <td className="text-center">
                                                            <input className="form-check-input" type="radio" value={v?.number} name={`sta${v.number}`} data-value={v.value} defaultChecked={true} data-type="lock" onClick={handleCheckbox} style={{ width: '18px', height: '18px' }} /></td>
                                                        <td className="text-center"><input className="form-check-input" type="radio" value={v?.number} name={`sta${v.number}`} data-value={v.value} data-type="cancel" onClick={handleCheckbox} style={{ width: '18px', height: '18px' }} /></td>
                                                    </tr>
                                                })}
                                                <tr>
                                                    <td colSpan={3}><b>Total</b></td>
                                                    <td><b>{orderTotals.lock}</b></td>
                                                    <td><b>{orderTotals.revert}</b></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    : <div className="text-center p-3">
                                        <br />
                                        <div style={{ margin: '0 auto' }}>
                                            <div className="loader" style={{ position: 'absolute', margin: '-2.5% 42.5%' }}></div>
                                            <img src="https://apiv2.dgddl.in/uploads/241002/241002_print.png" style={{ width: '22px', left: '26px', top: '30px' }} />
                                        </div>
                                        <br />
                                        <b>Please Wait...</b>
                                    </div>
                            }
                        </div>

                    </div>
                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-secondary"
                            onClick={() => setConfirmConvertModal(false)} >Close</button>
                        <button
                            type="button"
                            className={`btn btn-danger`}
                            onClick={() => ConvertInvoice(confirmConvertModal, confirmConvertData.proforma)} >Lock Invoice</button>
                    </div>
                </Modal>
            }

            {isRequestEditModalOpen && (
                <RequestEditModal
                    isOpen={isRequestEditModalOpen}
                    toggle={() => setIsRequestEditModalOpen(!isRequestEditModalOpen)}
                    documentType="invoice"
                    documentId={requestEditDoc?.invoice_number || requestEditDoc?.id}
                    documentNumber={requestEditDoc?.invoice_number}
                    onSuccess={() => {
                        setIsRequestEditModalOpen(false);
                        Notifications("Edit request submitted for admin approval", "success");
                    }}
                />
            )}
        </React.Fragment>
    )
}

export default InvoiceReport